import { Box } from '@mui/material';
import * as React from 'react';
import BookTable from './bookTable';

export default function BookLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <BookTable />
    </Box>
  );
}
